<template>
  <v-card>
    <v-card-title
      class="primary white--text py-1 my-0 title-sticky d-print-none"
    >
      {{ title }}
      <v-spacer></v-spacer>
      <slot name="titlebtns">
        <v-btn
          @click="closeAndTo(backRouteName, {}, {})"
          color="secondary"
          small
          tile
          class="mx-1"
        >
          <v-icon left dark>mdi-format-list-bulleted-square</v-icon>
          {{ t('返回列表') }}
        </v-btn>
        <v-btn
          v-if="canSave && !hideBtn"
          width="60"
          tile
          @click="save"
          color="success"
          small
          class="mx-1"
          :loading="loading"
        >
          {{ t('保存') }}
        </v-btn>
        <v-btn
          v-if="canSubmit && !hideBtn"
          width="80"
          tile
          @click="submit"
          color="success"
          small
          class="mx-1"
          :loading="sloading"
        >
          {{ t('保存并提交') }}
        </v-btn>
        <v-btn
          v-if="canPrint"
          width="60"
          tile
          @click="printElement(title)"
          color="primary"
          small
          class="mx-1"
        >
          {{ t('打印') }}
        </v-btn>
        <slot name="custombtns"></slot>
      </slot>
    </v-card-title>
    <slot name="topcontent"></slot>
    <div v-for="(s, i) in subtitles" :key="s">
      <v-card-title class="h6 mt-1 ml-1 left-border">
        {{ subtitleI18n && subtitleI18n[i] ? subtitleI18n[i] : s }}
        <!-- 显示多语言 -->
        <v-spacer></v-spacer>
        <slot :name="`${s}按钮`"></slot>
      </v-card-title>
      <slot :name="s"></slot>
      <!-- 保持插槽名称为原始 key -->
      <v-divider></v-divider>
    </div>
    <slot></slot>
    <iframe
      ref="printFrame"
      style="visibility: hidden; position: absolute"
    ></iframe>
  </v-card>
</template>
<script>
import routerControl from '@/mixin/routerControl'
import print from '@/mixin/print'
export default {
  name: 'v-detail-view',
  mixins: [routerControl, print],
  props: {
    title: String,
    backRouteName: String,
    subtitles: Array,
    subtitleI18n: Array,
    tooltip: String,
    canSubmit: [Boolean, String],
    canSave: {
      type: Boolean,
      default: true,
    },
    canPrint: [Boolean, String],
  },
  data() {
    return {
      hideBtn: false,
      loading: false,
      sloading: false,
      lang: this.getLangFromCookie(),
      messages: {
        zh: {},
        en: {},
      },
    }
  },

  watch: {
    tooltip(tooltip) {
      this.$store.commit('updateViewTagsTooltip', {
        tooltip,
        nowFullPath: this.$route.path,
      })
    },
  },

  methods: {
    getLangFromCookie() {
      const values = String(document.cookie || '')
        .split(';')
        .map((c) => c.trim())
        .filter((c) => c.startsWith('language='))
        .map((c) => c.substring('language='.length))
      const lang = values.length ? values[values.length - 1] : 'zh'
      return lang === 'en' ? 'en' : 'zh'
    },
    t(key) {
      return this.messages[this.lang]?.[key] || key
    },
    async emitPromise(method, ...params) {
      let listener =
        this.$listeners[method] || this.$attrs[method] || this[method]
      if (listener) {
        //one can additionally wrap this in try/catch if needed and handle the error further
        let res = await listener(...params)
        return res === undefined || res
      }
      return false
    },
    async save() {
      this.loading = true
      await this.emitPromise('save', () => {
        this.loading = false
        this.closeAndTo(this.backRouteName)
      })
      this.loading = false
    },
    async submit() {
      this.sloading = true
      await this.emitPromise('submit', () => {
        this.sloading = false
        this.closeAndTo(this.backRouteName)
      })
      this.sloading = false
    },
    updateTooltip(tooltip) {
      this.$store.commit('updateViewTagsTooltip', {
        tooltip,
        nowFullPath: this.$route.path,
      })
    },
  },
  created() {
    this.updateTooltip(this.tooltip)
  },
}
</script>

<style>
.left-border {
  position: relative;
}
.left-border::before {
  content: '';
  width: 5px;
  height: 30px;
  position: absolute;
  top: 25%;
  left: 0;
  background: #3399cc;
}
.title-sticky {
  position: sticky;
  top: 85px;
  z-index: 3;
}
</style>
